// Editorial Calm design tokens - lifted verbatim from the V1 Final prototype.

export const colors = {
    bg: '#0a0a0a',
    text: '#e8e6e0',
    textPrimary: '#f4f2ee',
    muted: 'rgba(232, 230, 224, 0.55)',
    dim: 'rgba(232, 230, 224, 0.4)',
    subtle: 'rgba(232, 230, 224, 0.28)',
    cardBg: '#121110',
    cardBgInner: '#0e0d0c',
    pillBg: '#16140f',
    trackEmpty: 'rgba(232, 230, 224, 0.06)',
} as const;

export const borders = {
    hairline: '1px solid rgba(232, 230, 224, 0.08)',
    hair2: '1px solid rgba(232, 230, 224, 0.04)',
} as const;

export const fonts = {
    display: "'Inter Tight', system-ui, sans-serif",
    mono: "'JetBrains Mono', monospace",
} as const;

export interface ScoreColor {
    hex: string;
    name: string;
    soft: string;
}

// 4-tier score color (Whoop-style: red → amber → lime → mint).
export function scoreColor(s: number): ScoreColor {
    if (s < 40) return { hex: '#ef4444', name: 'Foundation', soft: '#ef444422' };
    if (s < 65) return { hex: '#f59e0b', name: 'Developing', soft: '#f59e0b22' };
    if (s < 85) return { hex: '#84cc16', name: 'Integrated', soft: '#84cc1622' };
    return { hex: '#10b981', name: 'Strong', soft: '#10b98122' };
}

// Discrete intensity zones for patterns (no gradient).
//
// Polarity inverts the color logic for resource (engine) tags: a low
// growth-mindset is bad (red), a high one is good (green) - the opposite of
// shadow tags where high intensity is the alarm.
export function patternZone(
    pct: number,
    polarity: 'shadow' | 'engine' = 'shadow',
): { hex: string; soft: string; label: string } {
    const effective = polarity === 'engine' ? 100 - pct : pct;

    if (effective >= 80) return { hex: '#f87171', soft: '#f8717118', label: 'high' };
    if (effective >= 60) return { hex: '#fb923c', soft: '#fb923c18', label: 'elevated' };
    if (effective >= 40) return { hex: '#facc15', soft: '#facc1518', label: 'mid' };

    return { hex: '#4ade80', soft: '#4ade8018', label: 'low' };
}

export function pendulumZone(swingPct: number): {
    hex: string;
    soft: string;
    status: string;
} {
    if (swingPct >= 70) return { hex: '#f87171', soft: '#f8717122', status: 'WIDE SWING' };
    if (swingPct >= 45) return { hex: '#fb923c', soft: '#fb923c22', status: 'MODERATE' };
    if (swingPct >= 20) return { hex: '#facc15', soft: '#facc1522', status: 'NARROWING' };
    return { hex: '#4ade80', soft: '#4ade8022', status: 'BALANCED' };
}
